import { api } from './client';

export interface AppSettingItem {
  key: string;
  description: string | null;
  is_secret: boolean;
  has_value: boolean;
  value: string;
  masked: string | null;
  updated_at: string | null;
}

export interface TemplateRegistryItem {
  key: string;
  category: 'bot' | 'email';
  label: string;
  description: string;
  placeholders: string[];
  default: string;
  rows: number;
  value: string;
}

export const appSettingsApi = {
  list: () => api.get<AppSettingItem[]>('/api/v1/app-settings').then(r => r.data),
  update: (key: string, value: string) =>
    api.patch<AppSettingItem>(`/api/v1/app-settings/${key}`, { value }).then(r => r.data),
  testSmtp: (to: string) =>
    api.post<{ ok: boolean; message: string }>('/api/v1/app-settings/_test-smtp', { to }).then(r => r.data),
  templates: () =>
    api.get<TemplateRegistryItem[]>('/api/v1/app-settings/_templates').then(r => r.data),
  repoSync: () =>
    api.post<{
      ok: boolean; skipped: boolean; reason?: string;
      url?: string; branch?: string; revision?: string; cloned?: boolean;
      added?: number; updated?: number; skipped_files?: number;
      error?: string; step?: string;
    }>('/api/v1/integrations/repo-sync/run').then(r => r.data),
};
